import {
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';
import { ModelBoardFloorCreatableInterface } from '../interfaces/model-board-floor-creatable.interface';
import { BoardPurchaseFloorCascadableInterface } from 'src/modules/board-purchase-floor/interfaces/board-purchase-floor-cascadable.interface';

interface ModelBoardFloorUniqueValidatorValue
  extends ModelBoardFloorCreatableInterface,
    BoardPurchaseFloorCascadableInterface {}
@ValidatorConstraint({ name: 'modelBoardFloorUnique', async: false })
export class ModelBoardFloorUniqueValidator
  implements ValidatorConstraintInterface
{
  validate(modelBoardFloors: ModelBoardFloorUniqueValidatorValue[]) {
    if (!modelBoardFloors || modelBoardFloors?.length === 0) return true;

    const modelBoardFloorsUnique = new Set(
      modelBoardFloors.map(
        (modelBoardFloor) =>
          `${modelBoardFloor.floor}-${modelBoardFloor.boardTypeId}-${modelBoardFloor.phaseId}`,
      ),
    );

    return modelBoardFloors.length === modelBoardFloorsUnique.size;
  }

  defaultMessage() {
    return 'Duplicate board information is not allowed for a given phase - floor combination';
  }
}
